
namespace GeniuzPOS.LogManage {

    @Serenity.Decorators.registerClass()
    export class LogApiPathDialog extends Serenity.EntityDialog<LogApiPathRow, any> {
        protected getFormKey() { return LogApiPathForm.formKey; }
        protected getIdProperty() { return LogApiPathRow.idProperty; }
        protected getLocalTextPrefix() { return LogApiPathRow.localTextPrefix; }
        protected getNameProperty() { return LogApiPathRow.nameProperty; }
        protected getService() { return LogApiPathService.baseUrl; }
        protected getDeletePermission() { return LogApiPathRow.deletePermission; }
        protected getInsertPermission() { return LogApiPathRow.insertPermission; }
        protected getUpdatePermission() { return LogApiPathRow.updatePermission; }

        protected form = new LogApiPathForm(this.idPrefix);

    }
}